import React from 'react';

import CreatorUserFields from 'features/users/components/CreatorUserFields/CreatorUserFields';
import CreatorAddress from 'features/users/CreatorAddress';
import { Box, Flex } from 'shared/components/display';
import { DefinitionList, ListDetail } from 'shared/components/molecules/DefinitionList';

import { USER_COPY } from 'shared/config/copy';
import COLORS from 'shared/styles/colors';
import { BrkfstUser } from 'shared/typings/user';
import { CreatorUser } from 'shared/typings/user';

import InternalOnlyBadge from '../atoms/InternalOnlyBadge';

import styles from './styles';

interface Props {
  user: BrkfstUser;
}

const CreatorProfileInformation: React.FC<Props> = ({ user }) => {
  return (
    <Box css={styles} className="creator-profile-information">
      <DefinitionList uppercase>
        <Flex className="creator-profile-information__active-brief-count">
          <ListDetail text={USER_COPY.LABEL_ACTIVE_BRIEFS} color={COLORS.NEUTRAL500} uppercase>
            {`${(user as CreatorUser)?.inProgressBriefsCount || 0}`}
          </ListDetail>
          <InternalOnlyBadge showTooltip />
        </Flex>
        <ListDetail text="Email">
          <a href={`mailto:${user.email}`} target="_blank">
            {user.email}
          </a>
        </ListDetail>
      </DefinitionList>
      <CreatorAddress userId={user.id} />
      <CreatorUserFields user={user} />
      <DefinitionList uppercase>
        <ListDetail text="Internal Note" hide={!user.note}>
          {user.note || ''}
        </ListDetail>
      </DefinitionList>
    </Box>
  );
};

export default CreatorProfileInformation;
